var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"theme-color",staticStyle:{"height":"100%","overflow-x":"scroll"},attrs:{"fluid":""}},[_c('AirReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }